// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"AboutMe_AboutMe__AE5G3","description":"AboutMe_description__21suC","resumeContainer":"AboutMe_resumeContainer__QXce0"};